import { Paper, Box, Typography, Divider } from "@mui/material"
import { formatDate } from "config/helpers"
import DangerAlert from "../../shared/alerts/Danger"
import WarningAlert from "../../shared/alerts/Warning"
import SuccessAlert from "../../shared/alerts/Success"
import Diseases from "./Diseases"
import { Link as RouterLink } from "react-router-dom"
import useTranslation from "../../../hooks/use_translation"

const Card = (props) => {
  const { data } = props
  const { pages } = useTranslation()

  const selectCard = () => {
    const symptoms = data.symptoms
    const dangerMatches = symptoms.some((item) => item.danger === "high")
    const warningMatches = symptoms.some((item) => item.danger === "medium")

    if (dangerMatches) {
      return <DangerAlert />
    } else if (warningMatches) {
      return <WarningAlert />
    } else {
      return <SuccessAlert />
    }
  }

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: "15px",
        mb: 2.5,
        cursor: "pointer",
        textDecoration: "none",
        backgroundColor: "white",
      }}
      component={RouterLink}
      to={data.uuid}
    >
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Typography sx={{ fontWeight: 700 }}>{pages?.history_of_requests?.diagnostic}</Typography>
        <Typography variant="caption">{formatDate(data.created_at)}</Typography>
      </Box>
      <Divider sx={{ my: 2 }} />
      <Box>
        <Box sx={{ mb: 2.5 }}>{selectCard()}</Box>

        <Diseases data={data.possible_diseases} />
      </Box>
    </Paper>
  )
}

export default Card
